var KEYMAP = {

    'Start': Phaser.Keyboard.SPACEBAR,

    colorToggles: {
        r: Phaser.Keyboard.J,
        g: Phaser.Keyboard.K,
        b: Phaser.Keyboard.L
    },

    playerControls: {
        up: Phaser.Keyboard.W,
        down: Phaser.Keyboard.S,
        left: Phaser.Keyboard.A,
        right: Phaser.Keyboard.D,
        fire: Phaser.Keyboard.SPACEBAR
    }
    
}

module.exports = KEYMAP;



/*****************
 ** WEBPACK FOOTER
 ** ./src/gradience/config/keymap.js
 ** module id = 26
 ** module chunks = 0
 **/